import React, { useEffect, useRef, useState } from "react";
import "./confirmacao.scss";
import { CountdownBar } from "../../components/CountdownBar.tsx";
import TentativaStatus from "../../components/tentativas.tsx";
import HeaderHora from "../../components/headerHora.tsx";

import ReCAPTCHA from "react-google-recaptcha"; // ✅ 1) import

import { useNavigate } from "react-router-dom";

export default function ConfirmacaoIdentidadeCpf4() {
  const [digits, setDigits] = useState<string[]>(["", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [tentativas, setTentativas] = useState(() => {
    return Number(sessionStorage.getItem("tentativasCpf") || "1");
  });
  const [dados, setDados] = useState<any>();

  const siteKey = "6Lfjgu8mAAAAANjOcLLtNa43bJ385hyuW6aGvugW";

  const recaptchaRef = useRef<any | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const [showErrorToast, setShowErrorToast] = useState(false);

  const value4 = digits.join("");
  const canConfirmDigits = value4.length === 4 && digits.every((d) => /^\d$/.test(d));
  const canConfirm = canConfirmDigits && !!captchaToken;

  const navigate = useNavigate();

  const triggerErrorToast = () => {
    setShowErrorToast(true);
    setTimeout(() => {
      setShowErrorToast(false);
    }, 4000);
  };

  useEffect(() => {
    sessionStorage.setItem("tentativasCpf", String(tentativas));
  }, [tentativas]);

  useEffect(() => {
    inputRefs.current?.[0]?.focus?.();
    setDados(JSON.parse(sessionStorage.getItem("dadosLinkAtual")!));
  }, []);

  const setDigitAt = (idx: number, v: string) => {
    const only = v.replace(/\D/g, "");
    const next = [...digits];

    if (only.length > 1) {
      const arr = only.slice(0, 4).split("");
      for (let i = 0; i < 4; i++) next[i] = arr[i] ?? "";
      setDigits(next);
      const lastIndex = Math.min(3, arr.length - 1);
      inputRefs.current?.[lastIndex]?.focus?.();
      return;
    }

    next[idx] = only.slice(0, 1);
    setDigits(next);

    if (only.length === 1 && idx < 3) {
      inputRefs.current?.[idx + 1]?.focus?.();
    }
  };

  const handleKeyDown = (idx: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace") {
      if (digits[idx]) {
        const next = [...digits];
        next[idx] = "";
        setDigits(next);
      } else if (idx > 0) {
        inputRefs.current?.[idx - 1]?.focus?.();
        const next = [...digits];
        next[idx - 1] = "";
        setDigits(next);
      }
    }

    if (e.key === "ArrowLeft" && idx > 0) inputRefs.current?.[idx - 1]?.focus?.();
    if (e.key === "ArrowRight" && idx < 3) inputRefs.current?.[idx + 1]?.focus?.();
  };

  const confirm = () => {
    if (!canConfirm) return;

    const outDocumentoRaw = dados?.outDocumento ?? "";
    const docDigits = String(outDocumentoRaw).replace(/\D/g, "");
    const docFirst4 = docDigits.slice(0, 4);

    const isValid = docFirst4.length === 4 && value4 === docFirst4;

    if (isValid) {
      sessionStorage.setItem("validacaoCpfOk", "true");
      sessionStorage.removeItem("tentativasCpf");
      navigate("/", { replace: true });
      return;
    }
    else {
      triggerErrorToast();
      recaptchaRef.current?.reset?.();
      setCaptchaToken(null);

      setDigits(["", "", "", ""]);
      inputRefs.current?.[0]?.focus?.();

      setTentativas((prev) => {
        const next = prev + 1;
        sessionStorage.setItem("tentativasCpf", String(next));

        if (next >= 6) {
          try {
            sessionStorage.removeItem("dadosLinkAtual");
            sessionStorage.removeItem("sessionToken");
            sessionStorage.removeItem("sessionTokenBearer");
            sessionStorage.removeItem("sessionHash");
            localStorage.clear();
          } catch {}

          navigate("/finalizado", { replace: true });
        }

        return next;
      });

      return;
    }
  };

  return (
    <ThemeProvider>
      <div className="viewer-page">
        <div className="viewer-content">
          <div className="content">
            <div className="content-liveness confirm-cpf4">
              <div className="header">
                Confirmação de Identidade <HeaderHora/>
              </div>

              <div className="status-face status-cpf4">
                <CountdownBar />
                <TentativaStatus atual={tentativas} total={6} />
              </div>

              <div className="cpf4-body">
                <p className="cpf4-text">
                  Este é o ambiente seguro de validação de identidade do processo.{" "}
                  <strong>O link é individual e não deve ser utilizado por terceiros.</strong>{" "}
                  As consultas serão realizadas em bases oficiais para confirmação dos dados informados.
                  Verifique se o nome exibido corresponde à sua identidade e informe os{" "}
                  <strong>4 primeiros dígitos</strong> do seu CPF para prosseguir.
                </p>

                <p className="cpf4-subtitle">
                  <strong>Este processo está vinculado ao cadastro de:</strong>
                </p>

                <div className="cpf4-name-badge">{dados?.outNome ?? ""}</div>

                <p className="cpf4-hint">
                  Se o nome acima não for o seu, interrompa o processo.
                  <br />
                  <strong>Para continuar, informe os 4 primeiros dígitos do seu CPF.</strong>
                </p>

                <div className="cpf4-inputs" aria-label="Primeiros 4 dígitos do CPF">
                  {digits.map((d, idx) => (
                    <input
                      key={idx}
                      ref={(el: any) => (inputRefs.current[idx] = el)}
                      className="cpf4-digit"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      pattern="\d*"
                      maxLength={1}
                      value={d}
                      onChange={(e) => setDigitAt(idx, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(idx, e)}
                      aria-label={`Dígito ${idx + 1}`}
                    />
                  ))}
                </div>

                {/* ✅ 4) recaptcha renderizando e salvando token */}
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={siteKey}
                    onChange={(token: any) => setCaptchaToken(token)}
                    onExpired={() => setCaptchaToken(null)}
                  />
                </div>

                <div className="cpf4-footer-desktop">
                  <button
                    className="cpf4-confirm-btn"
                    onClick={confirm}
                    disabled={!canConfirm}
                  >
                    Confirmar identidade
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="viewer-footer viewer-footer-mobile">
          <button
            className="cpf4-confirm-btn"
            onClick={confirm}
            disabled={!canConfirm}
          >
            Confirmar identidade
          </button>
        </div>

        {showErrorToast && (
          <div className="toast-danger">
            Os 4 dígitos informados não conferem. Verifique e tente novamente.
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}

function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}